<template lang="pug">
div(data-testid="cmsMenu" class="absolute inset-x-0 top-full")
    Storyblok(:renderSections="data.sections" :forceLazyLoad="true")
</template>

<script>
import Storyblok from '@/integrations/storyblok/'
export default {
    name: 'CmsMenu',
    components: { Storyblok },
    props: {
        data: {
            type: Object,
            default() {
                return {}
            },
        },
    },
}
</script>
